module.exports = __webpack_public_path__ + "img/func_5_1.8a828f2d.svg";